import React from 'react'
import {Marketing} from "../components/marketing/Marketing";

export const MarketingPage = () => {
    return (
        <Marketing/>
    )
}
